module.exports = __webpack_public_path__ + "img/lightbulb-exclamation.cf0066ff.svg";